<div class="offer-container"
     [style.padding-left]="paddingLeft ? '' : '0'"
     [style.padding-right]="paddingRight ? '' : '0'"
>
  <div class="offer-cell-container" [style]="styleHeight" (click)="navigateToLink(card.link ?? '', 'container')">
    <div class="offer-cell-background-container">
      <div class="offer-cell-background"
           [style.background-image]="'url(' + card.img + ')'"
           [style]="card.style"
           [style.background-position]="stylePosition"
      ></div>
    </div>
    <div class="offer-cell"
         [class.hover-effect]="hover"
    >
      <h2 class="manrope mb-2 text-white figma-text-title" *ngIf="!showButton">
        <app-texts
          [texts]="[
            {text: card.title}
          ]"
        />
      </h2>
      <h2 class="manrope mb-2 text-white figma-text-title" *ngIf="showButton">
        <app-texts
          [texts]="[
            {text: card.title}
          ]"
        />
      </h2>
      <p class="manrope text-white offer-cell-hide fw-light animated-element figma-text-subtitle"
         [class.show]="showButton"
         [class.hidden]="!showButton">
        <app-texts
          [texts]="[
            {text: card.text}
          ]"
        />
      </p>
      <div class="animated-element"
           [class.show]="showButton && card.button"
           [class.hidden]="!showButton || !card.button"
           style="line-height: 100%"
      >
        <app-button [height]="45" (click)="navigateToLink(card.link ?? '', 'button')">
          <app-texts
            [texts]="buttonText"
          />
        </app-button>
      </div>
    </div>
    <div class="offer-cell-tag" *ngIf="(card.tag && card.tag.length > 0) || (card.tagRu && card.tagRu.length > 0)">
      <app-texts
        [texts]="[
          {text: [card.tagRu ?? '', card.tag ?? '']}
        ]"
      />
    </div>
  </div>
</div>
